import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import Donations from '../views/Donations.vue';
import FreeForAllRank from  '../views/FreeForAllRank.vue';
import Home from '../views/Home.vue'
import GuillotineStandings from '../views/GuillotineStandings.vue';
import Leaderboards from '../views/Leaderboards.vue';
import LeagueHistory from '../views/LeagueHistory.vue';
import ScheduleComparison from '../views/ScheduleComparison.vue';
import SeasonDetail from '../views/SeasonDetail.vue';
import SeasonList from '../views/SeasonList.vue';
import TitleBeltHistory from '../views/TitleBeltHistory.vue';

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/donate',
    name: 'Donations',
    component: Donations
  },
  {
    path: '/rank/freeforall',
    name: 'FFARank',
    component: FreeForAllRank
  },
  {
    path: '/guillotine',
    name: 'Guillotine',
    component: GuillotineStandings
  },
  {
    path: '/leaderboards',
    name: 'Leaderboarsd',
    component: Leaderboards,
  },
  {
    path: '/leaguehistory',
    name: 'LeagueHistory',
    component: LeagueHistory
  },
  {
    path: '/schedulecomparison',
    name: 'SeasonsScheduleComparison',
    component: ScheduleComparison
  },
  {
    path: '/seasons',
    name: 'Seasons',
    component: SeasonList
  },
  {
    path: '/seasons/:year',
    name: 'season-detail',
    component: SeasonDetail,
    props: true
  },
  {
    path: '/titlebelt',
    name: 'title-belt',
    component: TitleBeltHistory,
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
